import { Avatar, BedMapsIcon, ButtonLink, Check, ClosingBand, PageLabel } from '../parts.jsx';
import { KITCHEN_TAP_PHOTO, TERRACE_PHOTO, appLinks, unsplash } from '../navigation.js';

const notesLeft = [
  { number: 1, title: 'Photo first', line: 'Residents send a photo and answer up to three questions.' },
  { number: 2, title: 'Know before you visit', line: 'See what is wrong before anyone goes round.' },
];
const notesRight = [
  { number: 3, title: 'Prices before you choose', line: 'Checked local trades send a price and a time. You choose.' },
  { number: 4, title: 'Residents stay updated', line: 'They track the repair in the app, so they do not need to chase you.' },
];

function Notes({ notes }) {
  return <ul className="mk-notes">{notes.map((note) => <li key={note.number}>
    <p className="mk-note-head"><span className="mk-step-number is-32">{note.number}</span>{note.title}</p>
    <p className="mk-note-line">{note.line}</p>
  </li>)}</ul>;
}

export default function ForHousingProvidersPage() {
  const hero = (width) => `${unsplash(TERRACE_PHOTO, width)} ${width}w`;
  return <>
    <section className="mk-photo-hero" aria-labelledby="providers-title">
      <img className="mk-photo-hero-image" src={unsplash(TERRACE_PHOTO, 1600)} srcSet={[960, 1600, 2400, 3200].map(hero).join(', ')} sizes="100vw" alt={TERRACE_PHOTO.alt}/>
      <div className="mk-container mk-photo-hero-inner">
        <div className="mk-hero-panel">
          <PageLabel icon="building-2">For Housing Providers</PageLabel>
          <h1 className="mk-display is-52" id="providers-title">Get repair requests from residents.</h1>
          <p className="mk-lead is-20">Residents report repairs with a photo. We send them to your repairs team. Post jobs and get quotes from checked local trades.</p>
          <div className="mk-actions">
            <ButtonLink to={appLinks.housingProviderStart} size={56} big>Get started</ButtonLink>
            <ButtonLink to="/how-it-works#for-housing-providers" variant="soft" size={56} big>How it works</ButtonLink>
          </div>
          <div className="mk-checks"><Check>Works with BedMaps</Check><Check>Checked local trades</Check></div>
        </div>
      </div>
    </section>

    <section className="mk-band is-white" id="repair-requests" aria-labelledby="requests-title">
      <div className="mk-container mk-stack is-40">
        <h2 className="mk-h2" id="requests-title">Repair Requests</h2>
        <div className="mk-annotated">
          <Notes notes={notesLeft}/>
          <div className="mk-request-card">
            <div className="mk-request-top">
              <img className="mk-job-photo" src={unsplash(KITCHEN_TAP_PHOTO, 240)} alt={KITCHEN_TAP_PHOTO.alt} width="72" height="72"/>
              <div className="mk-job-text"><p className="mk-request-title">Dripping kitchen tap</p><p className="mk-request-line">Birmingham, B6 · Reported by a resident</p></div>
            </div>
            <ul className="mk-answers">{['Kitchen', 'Dripping', 'No water damage'].map((answer) => <li key={answer}>{answer}</li>)}</ul>
            <div className="mk-provider-quote">
              <Avatar initials="BP" size={44}/>
              <div className="mk-provider-quote-text"><p className="mk-provider-quote-trade">Brook Plumbing</p><p className="mk-provider-quote-when">Tomorrow at 10</p></div>
              <p className="mk-provider-quote-price">£85</p>
              <span className="mk-button is-primary is-h40">Choose</span>
            </div>
            <div className="mk-provider-quote">
              <Avatar initials="HP" size={44}/>
              <div className="mk-provider-quote-text"><p className="mk-provider-quote-trade">Hart Plumbing</p><p className="mk-provider-quote-when">Thursday morning</p></div>
              <p className="mk-provider-quote-price">£95</p>
            </div>
          </div>
          <Notes notes={notesRight}/>
        </div>
      </div>
    </section>

    <section className="mk-band is-wash" id="for-bedmaps-providers" aria-labelledby="bedmaps-title">
      <div className="mk-container mk-split is-centred">
        <div className="mk-split-copy is-520 is-gap-16">
          <BedMapsIcon size={44}/>
          <h2 className="mk-h2" id="bedmaps-title">For BedMaps Providers</h2>
        </div>
        <p className="mk-lead is-ink is-20 is-loose mk-split-text">BedMaps providers automatically have a connected resident portal for their tenants to report issues. Repairs reported there go straight to your housing team in BedMaps.</p>
      </div>
    </section>

    <ClosingBand title="Get Started" text="Get repair requests from residents. Invite the trades you already use." wideCopy>
      <ButtonLink to={appLinks.housingProviderStart} variant="white" size={56}>Get started</ButtonLink>
    </ClosingBand>
  </>;
}
